import React from 'react';

import './styles.scss';
import Loader from '../loader';
import {IJournalDialogue} from '../../redux/journal/interfaces';
import JournalCard from '../journal-card';

type Props = {
  cards: IJournalDialogue[];
  showLoader?: boolean;
  onLoadMore?: (count: number) => void;
  onClickCard: (journal: IJournalDialogue) => void;
  checkedCards?: number[];
  disabledButtons?: boolean;
}

export const JournalsCardSection = ({
  showLoader = false,
  cards,
  onClickCard
}: Props): JSX.Element => {
  function handleClickCard(journal: IJournalDialogue) {
    return () => {
      onClickCard(journal);
    };
  }

  return <section className="journals-card-section">
    {showLoader ? <Loader/> : <ul className="journals-card-section__list">
      {
        cards && cards.length && cards.map((card, i) => {
          return <li key={card.dialogId} className="journals-card-section__item">
            <JournalCard
              card={card}
              onClick={handleClickCard(card)}/>
          </li>;
        })
      }
    </ul>}
  </section>;
};
